<template>
  <footer class="footer">
    <ul class="footer__logo">
      <li class="footer__logo__yolo">
        <a
          href="https://yolo.style"
          target="_blank"
          rel="noopener"
        >
          <svg
            width="61.2"
            height="37.37"
            viewBox="0 0 68.39 41.72"
            role="image"
            aria-label="YOLO - You Only Live Once"
          >
            <use xlink:href="#logo-yolo" />
          </svg>
        </a>
      </li>
      <li class="footer__logo__speedo">
        <a
          href="https://www.goldwin.co.jp/speedo/"
          target="_blank"
          rel="noopener"
        >
          <svg
            width="114.76"
            height="21.6"
            viewBox="0 0 93.17 17.59"
            role="image"
            aria-label="speedo"
          >
            <use xlink:href="#logo-speedo" />
          </svg>
        </a>
      </li>
    </ul>
    <p class="footer__copyrights">
      <small>&copy; 2017-2022 YOLO style / PEACS Inc.</small>
    </p>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/foundation/config/colors";
@use "@/assets/scss/foundation/config/typography";
@use "@/assets/scss/foundation/config/mediaquery";
@use "@/assets/scss/foundation/mixin";

.footer {
  position: relative;
  z-index: 2;
  margin-top: -16px;
  padding: 64px 0 18px;
  color: colors.$color-bg-sub;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, white 20px);
  text-align: center;
  @include mediaquery.minMediaMajor {
    margin-top: -24px;
    padding: 104px 0 32px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 24px, white 24px);
  }

  &::before {
    display: block;
    @include mixin.absPosTL;
    width: 100%;
    height: 20px;
    background: url("@/assets/images/wave-line_pink-white.svg") repeat-x center bottom / auto 100%;
    content: "";
    @include mediaquery.minMediaMajor {
      height: 35px;
    }
  }
}

.footer--theme {
  color: white;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, colors.$color-bg 20px);
  &::before {
    background-image: url("@/assets/images/wave-line_pink-darkblue.svg");
  }
}

.footer--sub {
  color: white;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, colors.$color-bg-sub 20px);
  &::before {
    background-image: url("@/assets/images/wave-line_pink-blue.svg");
  }
}


.footer__logo {
  display: flex;
  justify-content: center;
  line-height: 1;

  li + li {
    margin-left: 36px;
  }

  a {
    display: block;
  }

  svg {
    fill: currentColor;
  }
}

.footer__logo__speedo svg {
  @include mediaquery.minMediaMajor {
    width: 85.2px;
    height: 52px;
  }
}

.footer__logo__speedo {
  margin-top: 5px;
  @include mediaquery.minMediaMajor {
    margin-top: 2px;
  }

  svg {
    @include mediaquery.minMediaMajor {
      width: 153.59px;
      height: 29px;
    }
  }
}


.footer__copyrights {
  margin-top: 25px;
  font-size: 1rem;
  font-weight: 500;
  @include mediaquery.minMediaMajor {
    margin-top: 20px;
    font-size: 1.2rem;
  }

  small {
    font-size: 1em;
  }
}
</style>
